<span class="wordBreak">{{name}}</span>